import { useRef, useMemo } from 'react';
import { CheckPicker, Checkbox, Button, Form } from 'rsuite';
import type { CheckPickerProps } from 'rsuite';
import styles from './ExMultiSelectionChecked.module.css';


interface Props extends Partial<CheckPickerProps<string>> {
  data: any;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  width?: number | string;
  applyLabel?: string;
  selectAllLabel?: string;
  inputlabel?:string
}

export default function ExMultiSelectionChecked({
  data,
  value,
  onChange,
  menuClassName,
  className,
  placeholder = 'Seleccionar...',
  width = '100%',
  applyLabel = 'Aplicar',
  selectAllLabel = 'Seleccionar todo',
  inputlabel,
  ...rest
}: Props) {
  const pickerRef = useRef<any>(null);

  const allValues = useMemo(() => data.map((item) => item.value), [data]);

  const handleCheckAll = (_value: any, checked: boolean) => {
    onChange(checked ? allValues : []);
  };

  return (
    <Form.Group style={{width:'100%', marginBottom:0}}>
    <Form.ControlLabel className={styles['label']}>{inputlabel} <span style={{color:'red'}}>*</span></Form.ControlLabel>
    <CheckPicker
      ref={pickerRef}
      data={data}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{ width }}
      menuClassName={menuClassName}
      className={className}
      renderExtraFooter={() => (
        <div className={styles.footer}>
          <Checkbox
            indeterminate={value.length > 0 && value.length < allValues.length}
            checked={value.length === allValues.length}
            onChange={handleCheckAll}
          >
            {selectAllLabel}
          </Checkbox>

          <Button
            appearance="primary"
            size="sm"
            className={styles.footerButton}
            onClick={() => pickerRef.current?.close()}
          >
            {applyLabel}
          </Button>
        </div>
      )}
      {...rest}
    />
    </Form.Group>
  );
}
